import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {FormService} from '../../../resources/services/form.service';
import {FormEntityExtension} from '../../../resources/extensions/form-entity-extension/form-entity.extension';
import {ValidateService} from '../../../resources/modules/validate/validate.service';
import {ToastrService} from 'ngx-toastr';
import {MessageService} from '../../../resources/services/message.service';
import {ProductType} from '../../../resources/utils/product';
import {FormEntityExtensionService} from "../../../resources/extensions/form-entity-extension/form-entity-extension.service";

@Component({
  selector: 'product-form',
  templateUrl: './product-form.component.html',
})
export class ProductFormComponent extends FormEntityExtension implements OnInit {

  constructor(protected formEntityExtensionService: FormEntityExtensionService,
              private formService: FormService) {
    super(formEntityExtensionService);
  }

  @Input('data') set data$(value) {
    if (!value) return;
    this.data = value;
    if (this.data.project) this.data.entity = 'project';
    else if (this.data.storeCollection) this.data.entity = 'storeCollection';
    this.patchValue();
  }

  subscriptionForm: any;
  consumableForm: any;
  nonConsumableForm: any;
  costForm: any;
  types: any = [
    ProductType.Subscription,
    ProductType.Consumable,
    ProductType.NonConsumable
  ];

  entities: any = [{
    label: 'Project',
    key: 'project'
  }, {
    label: 'Collection',
    key: 'storeCollection'
  }];

  ngOnInit(): void {
    this.initForm(
      new FormBuilder().group({
        name: ['', Validators.required],
        googleProductId: ['', Validators.required],
        appleProductId: ['', Validators.required],
        coinsCost: [''],
        innerProduct: [false],
        sandBox: [false],
        parentStore: [null, Validators.required],
        type: [null, Validators.required],
      }));

  }

  /**
   * необходимо свой initForm,
   * а не extension
   * @param formGroup
   */
  initForm(formGroup: FormGroup) {
    this.form = formGroup;
    this.initSubForm();
    this.patchValue();
    this.formGroup.emit(this.form);
    this.formEntityExtensionService.formService.setActiveForms([this.form]);
  }
  /**
   * необходим свой patch,
   * store => parentStore
   */
  patchValue() {
    if (this.data && this.form) {
      if (this.data.store)
        this.data.parentStore = this.data.store;

      this.setForm();
      this.form.patchValue(this.data);
      this.formEntityExtensionService.formService.setDefaultValues(this.form);
    }
  }

  initSubForm() {

    this.subscriptionForm = {
      subscriptionPeriod: new FormControl(null, [Validators.required]),
    };
    this.consumableForm = {
      coinsValue: new FormControl(null, [Validators.required]),
    };
    this.nonConsumableForm = {
      entity: new FormControl('storeCollection'),
      project: new FormControl(),
      storeCollection: new FormControl(),
    };
    this.costForm = {
      coinsCost: new FormControl(null, [Validators.required]),
    };

    this.initSubscription();
  }

  typeChange$: Subscription;
  costChange$: Subscription;
  initSubscription() {
    this.typeChange$ = this.form.get('type').valueChanges.subscribe((result) => {
      this.toggleByType(result);
    });
    this.costChange$ = this.form.get('innerProduct').valueChanges.subscribe((result) => {
      this.toggleByInnerProduct(result);
    })
  }

  toggleByType(result: any) {
    this.formService.toggleControls(this.form, this.subscriptionForm, result === ProductType.Subscription, this.data);
    this.formService.toggleControls(this.form, this.consumableForm, result === ProductType.Consumable, this.data);
    this.formService.toggleControls(this.form, this.nonConsumableForm, result === ProductType.NonConsumable, this.data);
  }

  toggleByInnerProduct(result: any) {
    this.formService.toggleControls(this.form, this.costForm, result === true);
  }

  setForm() {
    this.toggleByType(this.data.type);
    this.toggleByInnerProduct(this.data.innerProduct);
  }

}
